import Modal from "@/components/base/Modal";
import { cn } from "@/utils/cn";

interface ConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  description: string;
  confirmLabel: string;
  icon?: string;
  tone?: "primary" | "danger";
}

/**
 * Confirmation requise avant toute action administrative sensible
 * (suspendre, désactiver, réactiver, activer un compte).
 */
export default function ConfirmationModal({
  open,
  onClose,
  onConfirm,
  title,
  description,
  confirmLabel,
  icon = "ri-alert-line",
  tone = "primary",
}: ConfirmationModalProps) {
  const isDanger = tone === "danger";

  return (
    <Modal open={open} onClose={onClose} size="sm" title={title}>
      <div className="flex items-start gap-3">
        <span
          className={cn(
            "flex h-11 w-11 shrink-0 items-center justify-center rounded-full",
            isDanger ? "bg-primary-100 text-primary-700" : "bg-accent-100 text-accent-700"
          )}
        >
          <i className={cn(icon, "text-xl")} aria-hidden="true" />
        </span>
        <p className="pt-1 text-sm leading-relaxed text-foreground-700">{description}</p>
      </div>

      <div className="mt-5 flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
        <button
          type="button"
          onClick={onClose}
          className="inline-flex items-center justify-center whitespace-nowrap rounded-md border border-foreground-200 bg-background-50 px-5 py-2.5 text-sm font-label font-medium text-foreground-900 transition-colors hover:bg-background-100 cursor-pointer"
        >
          Annuler
        </button>
        <button
          type="button"
          onClick={onConfirm}
          className={cn(
            "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md px-5 py-2.5 text-sm font-label font-medium text-background-50 transition-colors cursor-pointer",
            isDanger ? "bg-primary-600 hover:bg-primary-700" : "bg-primary-500 hover:bg-primary-600"
          )}
        >
          <i className={cn(icon, "text-base")} aria-hidden="true" />
          {confirmLabel}
        </button>
      </div>
    </Modal>
  );
}